module.exports = __webpack_public_path__ + "img/list_black_24dp.e30a83fb.svg";